<template>
  <div>
    <HoverCard>
      <HoverCardTrigger>
        <Button v-show="hasNewVersion" variant="fill" color="glass" size="lg" shape="corner">
          <Icon icon="Technology-Fill-Update"></Icon> {{ $t('home.newVersion.title') }}
        </Button>
      </HoverCardTrigger>
      <HoverCardContent class="glass-m60 p-4 w-fit rounded-5xl">
        <div class="flex flex-col gap-4">
          <div class="flex items-center gap-2">
            <div
              class="flex items-center justify-center cursor-pointer glass-frosted size-12 rounded-8xl transition-colors"
            >
              <img
                src="@/assets/images/header/user/avatar-loggedIn.png"
                alt="User Avatar"
                class="size-8"
              />
            </div>
            <div class="flex flex-col">
              <span class="text-m-medium text-black-white">
                {{ $t('home.newVersion.description') }}
              </span>
              <span v-if="updateInfo?.version" class="text-s-medium text-text-glass-default">
                {{ $t('home.newVersion.latestVersion') }}{{ updateInfo?.version }}
              </span>
            </div>
          </div>
          <img
            v-if="releaseImg"
            :src="releaseImg"
            alt=""
            srcset=""
            class="rounded-xl brand-neutral-light-default1 w-88 h-49"
          />
          <div
            class="text-s-medium text-text-glass-default whitespace-pre-wrap"
            v-html="targetReleaseNotes"
          ></div>
          <Button color="black" @click="handleCheckUpdate">
            {{ $t('home.newVersion.updateButton') }}
          </Button>
        </div>
      </HoverCardContent>
    </HoverCard>
    <UpdateCheckDialog v-model:open="showDialog" />
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { useUpdateStore, useLocaleStore } from '@/stores'
  import { storeToRefs } from 'pinia'
  import { Button, Icon, HoverCard, HoverCardContent, HoverCardTrigger } from '@rapoo/element'
  import UpdateCheckDialog from '../settings/main/about/updateDialog/index.vue'
  const updateStore = useUpdateStore()
  const { hasNewVersion, updateInfo } = storeToRefs(updateStore)
  const localeStore = useLocaleStore()
  const { language } = storeToRefs(localeStore)

  // yml releaseNotes 数据
  const releaseNotes = computed(() => {
    return JSON.parse(updateInfo.value?.releaseNotes || '{}')
  })

  const releaseImg = computed(() => {
    console.log(updateInfo.value)
    return updateInfo.value?.releaseImg || ''
  })

  const targetReleaseNotes = computed(() => {
    const notes = releaseNotes.value?.notes || {}
    if (notes?.[language.value]) {
      return notes?.[language.value]
    }
    return releaseNotes.value || ''
  })

  const showDialog = ref(false)
  const handleCheckUpdate = async () => {
    updateStore.checkAndDownload()
    showDialog.value = true
  }
</script>
